import { useState, useContext } from 'react';
import { RefreshCw } from 'lucide-react';
import AuthContext from '../../../../../../../context/AuthContext';
import { useToast } from '../../../../../../../context/ToastContext';
import ConfirmationModal from '../../../../../../../components/ConfirmationModal';
import auditProgramService from '../../../../../../../services/audit_services/auditProgramService';

export default function ReopenProgramModal({ isOpen, onClose, programId, programTitle, onSuccess }) {
  const { authTokens } = useContext(AuthContext);
  const { showError, showSuccess } = useToast();
  const [loading, setLoading] = useState(false);

  const handleReopen = async () => {
    setLoading(true);
    
    try {
      const result = await auditProgramService.reopenAuditProgram(authTokens.access, programId);
      
      if (result.success) {
        showSuccess('Programme d\'audit rouvert avec succès');
        onSuccess();
        onClose();
      } else {
        showError(result.error || 'Erreur lors de la réouverture du programme d\'audit');
      }
      setLoading(false);
    } catch (error) {
      console.error('Error reopening audit program:', error);
      showError('Erreur lors de la réouverture du programme d\'audit');
      setLoading(false);
    }
  };

  return (
    <ConfirmationModal
      isOpen={isOpen}
      onClose={onClose}
      onConfirm={handleReopen}
      title="Rouvrir le programme d'audit"
      message={`Êtes-vous sûr de vouloir rouvrir le programme d'audit "${programTitle}" ? Cela changera le statut du programme en ouvert. Note : Les plans d'audit conserveront leur statut actuel.`}
      confirmText={loading ? 'Réouverture...' : 'Rouvrir le programme'}
      confirmButtonClass="bg-orange-600 hover:bg-orange-700"
      icon={<RefreshCw className="h-6 w-6 text-orange-600" />}
      loading={loading}
    />
  );
}